{
	"portfolioBlocks": {
		"blocks": "Блоки",
		"portfolioValue": "Портфель, USD",
		"profitability": "Доходность",
		"portfolioValuation": "Оценка портфеля",
		"riskLevel": "Уровень риска"
	}
}
